import { render, staticRenderFns } from "./CBox.vue?vue&type=template&id=e276538e&scoped=true&"
import script from "./CBox.vue?vue&type=script&lang=js&"
export * from "./CBox.vue?vue&type=script&lang=js&"
import style0 from "./CBox.vue?vue&type=style&index=0&id=e276538e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e276538e",
  null
  
)

export default component.exports